/**
 * 主包 i18n：仅挂载通用文案；业务域文案在 misc 分包 `ensureMiscLocales` 按需合并。
 *
 * @module locale/index
 */

import { createI18n } from 'vue-i18n'
import en from './en.json'
import zhHans from './zh-Hans.json'
import { resolveAppLocale, syncWotDesignLocale } from './locale-state'

const initialLocale = resolveAppLocale()

const i18n = createI18n({
  legacy: false,
  locale: initialLocale,
  fallbackLocale: 'zh-Hans',
  messages: {
    'zh-Hans': zhHans,
    en,
  },
  globalInjection: true,
})

syncWotDesignLocale(initialLocale)

/** 非 Vue 文件使用的翻译（须 key 已在主包或已 merge 的分包文案中） */
export function translate(key: string): string {
  const result = i18n.global.t(key)
  return typeof result === 'string' ? result : key
}

export default i18n
